import { ChangeDetectionStrategy, Component, computed, input, signal } from "@angular/core";
import { FieldTree } from "@angular/forms/signals";
import { NewDwellingTypeModel } from "../new-dwellings-filter.model";

@Component({
    selector: "new-dwellings-filter-estate-types",
    imports: [],
    templateUrl: "./new-dwellings-filter-estate-types.component.html",
    styleUrl: "./new-dwellings-filter-estate-types.component.scss",
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NewDwellingsFilterEstateTypesComponent {
    filterForm = input.required<FieldTree<NewDwellingTypeModel[]>>();
    expanded = signal(true);
    
    allSelected = computed(() => {
        const field = this.filterForm();
        return field().value().every((t) => t.selected);        
    });    

    toggleExpanded(): void {
        this.expanded.update((v) => !v);
    }

    toggleSelected(dwellingType: NewDwellingTypeModel): void {
        const field = this.filterForm();
        field().value.set(field().value().map((t) => (t.estateType === dwellingType.estateType ? { ...t, selected: !t.selected } : t)));
    }    

    selectAll(): void {
        const field = this.filterForm();
        field().value.update((types) => types.map((t) => ({ ...t, selected: !this.allSelected() })));
    }
}
